import React, { useEffect, useState, useMemo } from "react";
import ReactToPrint from "react-to-print";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./styling.css"
import { InputLabel, Select, MenuItem, FormControl, Box, ListSubheader, TextField, InputAdornment } from '@mui/material';
import SearchIcon from "@mui/icons-material/Search";
import company from "../../assets/company.png"
import axios from 'axios'
import { Link } from "react-router-dom"
import { numberToWords } from "amount-to-words";
import { FaAngleDown } from "react-icons/fa6";

const containsText = (text, searchText) =>
  text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;

const NewPurchaseReturnForm = ({handleChild}) => {

  const user = localStorage.getItem('user');
  const { role } = JSON.parse(user)

  const today = new Date().toISOString().split('T')[0];
  const currentTime = new Date().toLocaleTimeString('en-US', {
    hour12: false,
    hour: 'numeric',
    minute: 'numeric',
  });
  const defaultLogoUrl = company;
  const [companylogo, setCompanyLogo] = useState(defaultLogoUrl);
  const [vendorAddress, setVendorAddress] = useState("");
  const [newPurchaseReturnNumber, setnewPurchaseReturnNumber] = useState("");
  const [newpurchaseDate, setnewpurchaseDate] = useState(today);
  const [time, setTime] = useState(currentTime);
  const [quantity, setQuantity] = useState("");
  const [price, setPrice] = useState("");
  const [priceSQM, setPriceSQM] = useState("");
  const [pricePC, setPricePC] = useState("");
  const [priceSHT, setPriceSHT] = useState("");
  const [priceLMTR, setPriceLMTR] = useState("");
  const [amount, setAmount] = useState("0");
  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  const [notes, setNotes] = useState("");
  const [discount, setDiscount] = useState("0");
  const [grandTotal, setGrandTotal] = useState("")
  const [id, setID] = useState("");
  const [vendorID, setVendorID] = useState("");
  const [prDeliveryDate,setprDeliveryDate] = useState(today)

  const [selectedItem, setSelectedItem] = useState("");

  const [searchText, setSearchText] = useState("");

  const [selectedItem2, setSelectedItem2] = useState("");
  const [selectedUnit, setSelectedUnit] = useState("")
  const [type, setType] = useState("")

  //edit name
  const [selectedItemName, setSelectedItemName] = useState("");

  const [ItemData, setItemData] = useState([]);
  const displayedOptions = useMemo(
    () =>
      searchText
        ? ItemData.filter(
          (item) =>
            containsText(item.itemservice, searchText) ||
            containsText(item.id.toString(), searchText)
        )
        : ItemData,
    [ItemData, searchText]
  );

  const componentRef = React.createRef();

  const [VendorData, setVendorData] = useState([]);
  const [lpoNumber, setLpoNumber] = useState([]);


  const [Vendorname, setVendorname] = useState("");
  const [searchTextVendor, setSearchTextVendor] = useState("");

  const displayedVendorOptions = useMemo(
    () =>
      searchTextVendor
        ? VendorData.filter(
          (vendor) =>
            containsText(vendor.vendortitle, searchTextVendor) ||
            containsText(vendor.id.toString(), searchTextVendor)
        )
        : VendorData,
    [VendorData, searchTextVendor]
  );

  const [VendorPhone, setVendorPhone] = useState("");

  const [productData, setProductData] = useState([]);
  const [searchText2, setSearchText2] = useState('');
  const displayedOptions2 = useMemo(
    () =>
      searchText2
        ? productData.filter(
          (product) =>
            containsText(product.product_name, searchText2) ||
            containsText(product.id.toString(), searchText2)
        )
        : productData,
    [productData, searchText2]
  );

  const [notesData, setNotesData] = useState([]);
  const [searchText3, setSearchText3] = useState('');
  const displayedOptions3 = useMemo(
    () =>
      searchText3
        ? notesData.filter(
          (note) =>
            containsText(note.notenumber.toString(), searchText3)
        )
        : notesData,
    [notesData, searchText3]
  );
  const [toggle, setToggle] = useState(null);
  const [unitData, setUnitData] = useState([]);

  //edit name
  const [editName, setEditName] = useState(false);

  const NameToggle = () => {
      setEditName(!editName)
  };

  const handleLogoChange = (event) => {
    const newLogoUrl = URL.createObjectURL(event.target.files[0]);
    setCompanyLogo(newLogoUrl);
  };

  useEffect(() => {
    const getLastPurchaseReturn = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_BASE_URL}/purchase_return/get_last`);
        const parsed = await res.json()
        setnewPurchaseReturnNumber("Added upon print");

      } catch (error) {
        console.log(error)
      }
    }

    const fetchVendors = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/vendors/all_vendors`
        );
        const responseData = await response.json();
        if (responseData) {
          setVendorData(responseData.vendor);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    const fetchItems = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/itemservices/all_itemservices`
        );
        const responseData = await response.json();
        if (responseData) {
          setItemData(responseData.itemservice);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchAll_notes = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/notes/all_notes`);
        const responseData = await response.json()
        if (responseData) {
          setNotesData(responseData.note)
        }
      } catch (error) {
        console.log(error.message);
      }
    }

    getLastPurchaseReturn();
    fetchVendors();
    fetchItems();
    fetchAll_notes();
  }, []);




  useEffect(() => {
    if (selectedItem.length !== 0) {
      const selectedItemData = ItemData.find(
        (item) => item.itemservice === selectedItem
      );
      if (selectedItemData) {
        setSelectedItem2("")
        // setPrice(selectedItemData.rate);
        setPriceSQM(selectedItemData.rateSQM);
        setPricePC(selectedItemData.ratePC);
        setPriceSHT(selectedItemData.rateSHT);
        setPriceLMTR(selectedItemData.rateLMTR);
        const calculatedAmount = (price || priceSQM || pricePC || priceSHT || priceLMTR) * quantity;
        setAmount(calculatedAmount);
        setID(selectedItemData.id)
        setType(selectedItemData.type)
      }
    }
    if (selectedItem2.length !== 0) {
      const selectedItemData = productData.find(
        (product) => product.product_name === selectedItem2
      );
      if (selectedItemData) {
        setSelectedItem("")
        // setPrice(selectedItemData.product_rate);
        const calculatedAmount = price * quantity;
        setAmount(calculatedAmount);
        setID(selectedItemData.id)
        setType("product")
      }
    }
  }, [selectedItem, quantity, selectedItem2, priceSQM, pricePC, priceSHT, priceLMTR]);

  const priceFunc = (selUnit) => {
    const temp = unitData.filter((unit)=>unit.uom===selUnit)
    setPrice(temp[0].price)
};

//UOM item
const [itemId,setItemId]=useState(null)
useEffect(()=>{
    async function get_UOM(){
 
        try {
            const requestOptions = {
                method: 'POST', // or 'PUT', 'DELETE', etc. depending on your API endpoint
                headers: {
                'Content-Type': 'application/json', // Specify the content type
                },
                body: JSON.stringify({ item_id: `itm${itemId}` }), // Convert your body data to JSON format
            };

            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/invoices/get_UOM`,requestOptions);
            const responseData = await response.json()
            if (responseData) {
                setUnitData(responseData.invoice)
            }
        } catch (error) {
            console.log(error.message);
        }
    }
    get_UOM()

},[selectedItem])


//UOM product
const [productId,setProductId]=useState(null)
useEffect(()=>{
    async function get_UOM(){
 
        try {
            const requestOptions = {
                method: 'POST', // or 'PUT', 'DELETE', etc. depending on your API endpoint
                headers: {
                'Content-Type': 'application/json', // Specify the content type
                },
                body: JSON.stringify({ item_id: `pd${productId}` }), // Convert your body data to JSON format
            };

            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/invoices/get_UOM`,requestOptions);
            const responseData = await response.json()
            if (responseData) {
                setUnitData(responseData.invoice)
            }
        } catch (error) {
            console.log(error.message);
        }
    }
    get_UOM()

},[selectedItem2])

  useEffect(() => {
    const calculatedAmount = price * quantity;
    setAmount(calculatedAmount);
  }, [price, quantity])

  const addToTable = () => {
    if ((selectedItem || selectedItem2) && id && quantity && price && amount) {

      const newItem = {
        id: id,
        itemdesc: selectedItem.length > 0 ? selectedItemName : "",
        quantity: quantity,
        price: price,
        uom: selectedUnit,
        amount: amount,
        type: type
      };

      setList([...list, newItem]);

      setSelectedItem("");
      setQuantity("");
      setPrice("");
      setAmount("");
      setSelectedUnit("")

    }
  };

  const removeItem = (index) => {
    const updatedList = [...list];
    updatedList.splice(index, 1);
    setList(updatedList);
  };

  const clearFields = () => {
    setAmount("0")
    setTime("")
    setnewpurchaseDate("")
    setprDeliveryDate("")
    setVendorAddress("")
    setVendorID("")
    setVendorname("")
    setLpoNumber("")
    setList([])
    setVendorPhone("")
    setNotes("")
    setDiscount("")
    setnewPurchaseReturnNumber("")
    setSelectedItem("")
    setTotal(0)
    setQuantity("")
    setPrice("")
    setType("")
  }

  useEffect(() => {
    const calculateTotal = () => {
      let totalAmount = 0;

      // Calculate total amount without discount
      list.forEach(({ amount }) => {
        totalAmount += parseFloat(amount);
      });
      setGrandTotal(totalAmount);

      // Apply the discount
      const discountedTotal = totalAmount - parseFloat(discount);

      return discountedTotal;
    };

    const newTotal = calculateTotal();
    setTotal(newTotal);
  }, [list, discount]);


  const handleVendorChange = (selectedVendorName) => {
    let selectedVendor = VendorData.find((vendor) => vendor.vendortitle === selectedVendorName);
    if (selectedVendor) {
      setVendorAddress(selectedVendor.address || "");
      setVendorPhone(selectedVendor.phone || "")
      setVendorID(selectedVendor.id || "")
      setLpoNumber(selectedVendor.lponumber || "")
    }
  };

  const [triggerPRR,setTriggerPRR] = useState(true)
  const [triggerPrint, setTriggerPrint] = useState(false)

  const addnewpurchase = async () => {
    if (!Vendorname || !time || !newpurchaseDate || !total || !list) {
      toast.warn("Fill out the fields")
      return
    }

    try {
      setAddnewpurchaseButtonStatetext("Creating, please wait!")
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/purchase_return/add_purchasereturn`, {
        data: {
          "purchase_return_number": newPurchaseReturnNumber,
          "paymenttype": "paymentType Yet to be added",
          "vendor": Vendorname,
          "purchase_date": newpurchaseDate,
          "vendorid": vendorID,
          "discount": discount,
          "total": total,
          "items": list,
          "vendorlpo": lpoNumber,
          "vendoraddress": vendorAddress,
          "vendorphone": VendorPhone,
          "time": time,
          "notes": notes
        }
      });
      if (response.status === 200) {
        toast.success("new purchase return created successfully!");
        setAddnewpurchaseButtonStatetext("Create new purchase return");
        setnewPurchaseReturnNumber(`VPRR${response.data.purchasereturnId}`)
        setTriggerPRR(false)
        setTriggerPrint(true)        
      } else {
        toast.error("Error creating newpurchase return.");
      }
    } catch (error) {
      console.error(error.message);
      toast.error("Error creating note.")
    }

  }

  const [AddnewpurchaseButtonStatetext, setAddnewpurchaseButtonStatetext] = useState('Create new purchase return');

  useEffect(()=>{
    setPrice("")
    setSelectedUnit("")
  },[selectedItem,selectedItem2])

  return (
    <>
      <main
        className="m-5 p-5 xl:grid grid-cols-2 gap-10 xl:items-start"
        style={{
          maxWidth: "1920px",
          margin: "auto",
        }}
      >
        <section>
          <div className="bg-white p-5 rounded shadow">
            <div className="flex flex-col justify-center">
              <div>
                <img className="border-dashed mb-1 w-full h-full hover:bg-[#b5bac5] transition 1s cursor-pointer border-4 border-light-blue-500" src={companylogo} alt="" />

                {/* Input for changing the logo */}
                <input type="file" accept="image/*" onChange={handleLogoChange} />

                {/* Button to reset to the default logo */}
                <button className="bg-black text-white ml-3 p-2 rounded-md" onClick={() => setCompanyLogo(defaultLogoUrl)}>
                  Reset to Default Logo
                </button>
                <button className="bg-red-800 text-white ml-3 p-2 rounded-md" onClick={clearFields}>
                  Clear
                </button>
              </div>

              <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

              <article className=" gap-10">
                <div className="flex flex-col gap-4">
                  <article className="md:grid grid-cols-2 gap-5">
                    <FormControl fullWidth>
                      <InputLabel id="vendorname">Vendor's name</InputLabel>
                      <Select
                        labelId="vendorname"
                        id="vendorname"
                        value={Vendorname}
                        label="Vendorname"
                        onChange={(e) => {
                          setVendorname(e.target.value);
                          handleVendorChange(e.target.value);
                        }}
                        sx={{}}
                      >
                        <MenuItem value="" disabled>
                          Select a Vendor
                        </MenuItem>
                        <ListSubheader>
                          <TextField
                            size="small"
                            autoFocus
                            placeholder="Type to search..."
                            fullWidth
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <SearchIcon />
                                </InputAdornment>
                              )
                            }}
                            onChange={(e) => setSearchTextVendor(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key !== "Escape") {
                                e.stopPropagation();
                              }
                            }}
                          />
                        </ListSubheader>
                        {displayedVendorOptions.map((vendor, index) => (
                          <MenuItem key={index} value={vendor.vendortitle}>
                            {`${vendor.vendortitle} (ID: ${vendor.id})`}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <div className=" flex gap-3 items-center w-full">
                        <p className=" text-[20px] italic">OR</p>
                        <Link className=" w-full" to="/dashboard/vendors"><button className="hover:bg-blue-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-blue-400 bg-blue-800 font-bold text-white w-full p-2 rounded-md">+ Add New Vendor</button></Link>
                    </div>
                  </article>
                  <article className="md:grid grid-cols-2 gap-5">
                    <div className="flex flex-col">
                      <label htmlFor="vendorAddress">
                        Vendor's address
                      </label>
                      <input
                        type="text"
                        name="vendorAddress"
                        id="vendorAddress"
                        placeholder="Vendor's address"
                        autoComplete="off"
                        value={vendorAddress}
                        onChange={(e) => setVendorAddress(e.target.value)}
                        disabled
                      />
                    </div>
                    <div className="flex flex-col">
                      <label htmlFor="vendorPhone">
                        Vendor's phone
                      </label>
                      <input
                        type="text"
                        name="vendorPhone"
                        id="vendorPhone"
                        placeholder="Vendor's phone"
                        autoComplete="off"
                        value={VendorPhone}
                        onChange={(e) => setVendorPhone(e.target.value)}
                        disabled
                      />
                    </div>
                    <div className="flex flex-col">
                      <label htmlFor="vendorID">
                        Vendor's ID
                      </label>
                      <input
                        type="text"
                        name="vendorID"
                        id="vendorID"
                        placeholder="Vendor's ID"
                        autoComplete="off"
                        value={vendorID}
                        disabled
                      />
                    </div>
                    {/* {lpoNumber && ( */}
                    <div className="flex flex-col">
                      <label htmlFor="vendorID">
                        Vendor's Lpo Number
                      </label>
                      <input
                        type="text"
                        name="vendorLpo"
                        id="vendorLpo"
                        placeholder="Vendor's Lpo No."
                        autoComplete="off"
                        value={lpoNumber}
                        onChange={(e) => setLpoNumber(e.target.value)}
                      />
                    </div>
                    {/* )} */}
                  </article>
                </div>
              </article>
              {/* <Link className=" w-fit" to="/vendors"><button className="hover:bg-blue-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-blue-400 bg-blue-800 mb-3 w-[100px] font-bold text-white ml-3 p-2 rounded-md">+ Vendor</button></Link> */}
              <article className="md:grid grid-cols-3 gap-10">
                <div className="flex flex-col">
                  <label htmlFor="newPurchaseReturnNumber">PR number</label>
                  <input
                    type="text"
                    name="newPurchaseReturnNumber"
                    id="newPurchaseReturnNumber"
                    min="0"
                    placeholder="newpurchase return number"
                    autoComplete="off"
                    value={newPurchaseReturnNumber}
                    onChange={(e) => setnewPurchaseReturnNumber(e.target.value)}
                    disabled
                  />
                </div>

                <div className="flex flex-col">
                  <label htmlFor="newpurchaseDate">Purchase Date</label>
                  <input
                    type="date"
                    
                    name="newpurchaseDate"
                    id="newpurchaseDate"
                    placeholder="newpurchase Date"
                    autoComplete="off"
                    value={newpurchaseDate}
                    onChange={(e) => setnewpurchaseDate(e.target.value)}
                  />
                </div>

                <div className="flex flex-col">
                  <label htmlFor="dueDate">Time</label>
                  <input
                    type="time"
                    
                    name="time"
                    id="time"
                    placeholder="newpurchase Time"
                    autoComplete="off"
                    value={time}
                    onChange={(e) => setTime(e.target.value)}
                  />
                </div>
              </article>

              <article>
                <ToastContainer position="top-right" theme="colored" />
                <div className=" flex gap-3 items-center justify-between mb-3">
                  <button className=" w-full py-1 text-center text-white bg-green-700 rounded-lg" onClick={(e) => setToggle(false)}>Select Item/Service</button>
                </div>

                {toggle === false && (<>

                  <Box sx={{}}>
                    <FormControl fullWidth>
                      <InputLabel id="item">Select Item</InputLabel>
                      <Select
                        labelId="item"
                        id="item"
                        value={selectedItem}
                        label="Item & Services"
                        onChange={(e,item) => {
                          setSelectedItem(e.target.value)
                          setItemId(item.props.id)
                          setSelectedItemName(e.target.value)
                      }}
                        sx={{ mb: 1 }}
                      >
                        <MenuItem value="" disabled>
                          Select an Item
                        </MenuItem>
                        <ListSubheader>
                          <TextField
                            size="small"
                            autoFocus
                            placeholder="Type to search..."
                            fullWidth
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <SearchIcon />
                                </InputAdornment>
                              )
                            }}
                            onChange={(e) => setSearchText(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key !== "Escape") {
                                e.stopPropagation();
                              }
                            }}
                          />
                        </ListSubheader>
                        {/* <ListSubheader sx={{fontSize:18, color:"grey", borderBottom:1, borderTop:1, fontStyle:"italic"}}>Services</ListSubheader>
                        {displayedOptions.filter(item => item.type === 'Service').map((item, index) => (
                            <MenuItem key={index} id={item.id} value={item.itemservice}>
                                {`${item.itemservice}`}<span className=" ml-2 text-[12px] italic text-gray-500">ID: {item.id}</span>
                            </MenuItem>
                        ))} */}
                        <ListSubheader sx={{fontSize:18, color:"grey", borderBottom:1, borderTop:1, fontStyle:"italic"}}>Items</ListSubheader>
                        {displayedOptions.filter(item => item.type === 'Item').map((item, index) => (
                            <MenuItem key={index} id={item.id} value={item.itemservice}>
                                {`${item.itemservice}`}<span className=" ml-2 text-[12px] italic text-gray-500">ID: {item.id}</span>
                            </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <button onClick={NameToggle} className=" mb-1 w-full text-center bg-transparent flex justify-end items-center  gap-1 text-green-600">
                          <p className=" italic">Edit Name</p>
                          {React.createElement(
                              FaAngleDown,    
                              {
                              size: "15",
                              style: {
                                  transform: editName ? 'rotate(180deg)' : 'rotate(0deg)',
                                  transition: 'transform 0.3s ease',
                                  transitionDelay: `${0 + 0.7}00ms`, // Adjust duration and easing as needed
                              }
                              }
                          )}
                      </button>
                      {(selectedItem && (editName === true )) &&
                          <>
                              <input
                                  type="text"
                                  name="itemName"
                                  id="itemname"
                                  disabled={false}
                                  placeholder={selectedItemName}
                                  value={selectedItemName}
                                  onChange={(e) => setSelectedItemName(e.target.value)}
                                  className=" text-black w-full"
                              />
                          </>}
                  </Box>
                  {(

                    <>
                      <FormControl fullWidth>
                        <InputLabel id="unit">Unit of Measurement</InputLabel>
                        <Select
                          labelId="unit"
                          id="unit"
                          value={selectedUnit}
                          label="Unit of Measurement"
                          onChange={(e) => {
                            setSelectedUnit(e.target.value)
                            priceFunc(e.target.value)
                          }}
                          sx={{ mb: 4 }}
                        >
                          {unitData.map((unit, index) => (
                            <MenuItem key={index} value={unit.uom}>
                              {unit.uom}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </>
                  )}
                </>)}


                <div className="md:grid grid-cols-3 gap-10">
                  <div className="flex flex-col">
                    <label htmlFor="quantity">Quantity</label>
                    <input
                      type="number"
                      name="quantity"
                      id="quantity"
                      min="0"
                      step={1}
                      placeholder="Quantity"
                      value={quantity}
                      onChange={(e) => setQuantity(e.target.value)}
                    />
                  </div>


                  <div className="flex flex-col">
                    <label htmlFor="price">Price</label>
                    <input

                      type="number"
                      name="price"
                      id="price"
                      placeholder="Price"
                      value={price}
                      onChange={(e) => setPrice(e.target.value)}
                    />
                  </div>

                  <div className="flex flex-col">
                    <label htmlFor="amount">Amount</label>
                    <p className="text-[20px] mt-[7px] font-poppins text-red-600">{amount}</p>
                  </div>
                </div>
              </article>


              {(selectedItem.length > 0 || selectedItem2.length > 0) && quantity > 0 ? (<button className="text-5xl font-poppins bg-green-800 font-bold text-white" onClick={addToTable}>+</button>) : (null)}
              <table width="100%" className="mb-10 overflow-auto">
                <thead>
                  <tr className=" text-center bg-gray-100 p-1">
                    <td className="font-bold">Description</td>
                    <td className="font-bold">Quantity</td>
                    <td className="font-bold">Price</td>
                    <td className="font-bold">Amount</td>
                    <td className="font-bold">Actions</td>
                  </tr>
                </thead>
                {list?.map(({ id, itemdesc, quantity, price, amount }, index) => (
                  <React.Fragment key={id}>
                    <tbody>
                      <tr className=" text-center h-10">
                        <td>{itemdesc}</td>
                        <td>{quantity}</td>
                        <td>{price}</td>
                        <td className="amount">{amount}</td>
                        <td>
                          <button className="text-3xl font-poppins text-red-700" onClick={() => removeItem(index)}>x</button>
                        </td>
                      </tr>
                    </tbody>
                  </React.Fragment>
                ))}
              </table>

              <div className="flex flex-col">
                <label htmlFor="discount">Discount</label>
                <input
                  type="number"
                  name="discount"
                  id="discount"
                  min="0"
                  placeholder="Discount"
                  autoComplete="off"
                  value={discount}
                  onChange={(e) => setDiscount(e.target.value)}
                />
              </div>

              <label htmlFor="notes">Description</label>
              <textarea
                name="notes"
                id="notes"
                cols="30"
                rows="2"
                placeholder="newpurchase Description"
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
              ></textarea>

              {triggerPRR && (<button onClick={addnewpurchase} className="bg-green-500 ml-5 text-white font-bold py-2 px-8 rounded hover:bg-green-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-green-400">
                {AddnewpurchaseButtonStatetext}
              </button>)}
              
              {triggerPrint && (<ReactToPrint
                  onAfterPrint={()=>{
                      clearFields()
                      handleChild()
                  }}
                  trigger={() => (
                  <button className="bg-green-500 ml-5 text-white font-bold py-2 px-8 rounded hover:bg-green-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-green-400">
                      Click here to Print
                  </button>
                  )}
                  content={() => componentRef.current}
              />)}
            </div>
          </div>
        </section>


        {/* newpurchase Preview */}
        <div className="newpurchase__preview bg-white p-5 rounded-2xl border-4 border-blue-200  ">
          <ReactToPrint
            trigger={() => (
              <button className="bg-blue-500 ml-5 text-white font-bold py-2 px-8 rounded hover:bg-blue-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-blue-400">
                Print / Download
              </button>
            )}
            content={() => componentRef.current}
          />
          <div ref={componentRef} className="py-5 px-8 flex flex-col min-h-full print:w-[210mm] print:h-[100mm] relative">

            <div>
                <div className="flex flex-col items-center justify-center mb-5 xl:flex-row xl:justify-center w-full">
                    <div>

                        <img  src={companylogo} alt="logo" />
                    </div>
                </div>
              <article className=" py-2 text-center text-base text-black border-t border-b border-black uppercase w-full font-bold">
                <p>Purchase Return</p>
              </article>
              <div className=" flex justify-between my-5">
                <article className=" flex items-start justify-start">
                  <ul>
                    <li className="p-1 ">
                      <span className="font-bold">Supplier:</span> {Vendorname}
                    </li>
                    <li className="p-1">
                      <span className="font-bold">Address:</span> {vendorAddress}
                    </li>
                    {/* <li className="p-1">
                      <span className="font-bold">Delivery Date:</span> NaN
                    </li> */}
                    <li className="p-1 ">
                      <span className="font-bold">Phone:</span> {VendorPhone}
                    </li>
                    <li className="p-1 ">
                      <span className="font-bold">Delivery at:</span> AL RUKAIE CONTRACTING & TRADING CO.
                    </li>
                  </ul>
                </article>
                <article className=" flex items-end justify-end">
                  <ul>
                    <li className="p-1 ">
                      <span className="font-bold">Purchase Return No :</span> {newPurchaseReturnNumber}
                    </li>
                    <li className="p-1 ">
                      <span className="font-bold">Purchase date:</span> {newpurchaseDate}
                    </li>
                    <li className="p-1 ">
                      <span className="font-bold">Time:</span> {time}
                    </li>
                    <li className="p-1 ">
                      <span className="font-bold">Date:</span> {today}
                    </li>
                    {/* {lpoNumber && ( */}
                    <li className="p-1 ">
                      <span className="font-bold">LPO No:</span> {lpoNumber}
                    </li>
                    {/* )} */}

                  </ul>
                </article>
              </div>

              <table width="100%" className="mb-10">
                <thead>
                  <tr className=" text-center bg-gray-100 p-1 py-2 text-base text-black border-t border-b border-black uppercase w-full font-semibold">
                    <td className="font-bold">S.No.</td>
                    <td className="font-bold">Item Code</td>
                    <td className="font-bold">Description</td>
                    <td className="font-bold">UOM</td>
                    <td className="font-bold">Quantity</td>
                    <td className="font-bold">Price</td>
                    <td className="font-bold">Total</td>
                  </tr>
                </thead>
                {list?.map(({ id, itemdesc, uom, quantity, price, amount }, index) => (
                  <React.Fragment key={id}>
                    <tbody>
                      <tr className=" text-center h-10">
                        <td>{index + 1}</td>
                        <td>{id}</td>
                        <td>{itemdesc}</td>
                        <td>{uom}</td>
                        <td>{quantity}</td>
                        <td>{price}</td>
                        <td>{amount}</td>
                      </tr>
                    </tbody>
                  </React.Fragment>
                ))}
              </table>

              <div className="pl-2 pr-2 flex border-[3px] border-black rounded-lg flex-row items-center justify-evenly gap-2">
                <div className="flex flex-col justify-center items-start gap-1">
                  <h2 className="flex text-gray-800 text-1xl font-semibold">
                    In words
                  </h2>
                  <h2 className="flex text-gray-800 text-[17px] font-bold">
                    (QR. {numberToWords(total)} Only)
                  </h2>
                </div>
                <div className="flex flex-col justify-center items-start gap-1">
                  <h2 className="flex text-gray-800 text-[17px] font-bold">
                    TOTAL
                  </h2>
                  <h2 className="flex text-gray-800 text-1xl font-semibold">
                    Discount in Amount
                  </h2>
                  <h2 className="flex text-gray-800 text-[17px] font-bold">
                    NET TOTAL
                  </h2>
                </div>
                <div className="flex flex-col justify-center items-start gap-1">
                  <h2 className="flex text-gray-800 text-[17px] font-bold">
                    {Math.round(grandTotal)}
                  </h2>
                  <h2 className="flex text-gray-800 text-1xl font-semibold">
                    {discount}
                  </h2>
                  <h2 className="flex text-gray-800 text-[17px] font-bold">
                    {Math.round(total).toLocaleString()}
                  </h2>
                </div>
              </div>
            </div>

            <section className="mt-2 w-full flex flex-row justify-between items-start gap-2 mb-2">
              <h3 className="font-bold">Note:-</h3>
              <div className="flex w-[70%] flex-col justify-center items-start gap-1">
                <p className="w-full text-justify">1. Order placed subject to the goods being supplied by in compliance with the agency laws of the country and the vendor has attained all necessary permits.</p>
                <p className="w-full text-justify">2. Orginal LPO to be submitted along with the delivery.</p>
                <p className="w-full text-justify">3. All the products must have Barcode.</p>
                <p className="w-full text-justify">4. Products not moving with in 90 days will be returned back without any consent.</p>
                <p className="w-full text-justify">5. The Product will be returned, <span className="underline font-semibold capitalize">2 MONTHS BEFORE EXPIRY</span>, without any consent.</p>
                <p className="w-full text-justify">6. THIS LPO IS VALID FOR <span className="underline font-bold capitalize">15 DAYS ONLY.</span></p>
              </div>
              <div className="flex flex-col mt-[70px] gap-4 justify-center items-center">
                <p className="lg:w-full text-center">Approved By</p>
                <div className="w-full border-b-black border-2"></div>
              </div>
            </section>

            {notes &&
              <section className="mt-2 mb-2">
                <h3 className="font-bold">Remarks:</h3>
                <p className="lg:w-1/2 text-justify">{notes}</p>
              </section>
            }

            <footer className=" footer border-t-2 border-gray-300 pb-5">
              <ul className="flex flex-wrap items-center gap-2 justify-center">
                <li>
                  <span className="font-bold">Email:</span> {"arcoglassqatar@gmail.com"}
                </li>
                <li>
                  <span className="font-bold">Tel:</span> {"4460 5198"}<span className="ml-1 font-bold">-Fax:</span> {"4451 7172"}
                </li>
                <li>
                  <span className="font-bold">P.O Box:</span> {"40992, Doha-Qatar "}
                </li>
              </ul>
              <p className="text-center px-5 mt-4 text-xs ">
                Thankyou for your purchase!
              </p>
            </footer>

          </div>
        </div>
      </main>
    </>
  )
}

export default NewPurchaseReturnForm